import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'plan_order': {
    title: '单据编号',
    type: 'input',
    equation: all,
    slot: true
  },
  'plan_number': {
    title: '销售计划编号',
    type: 'input',
    equation: all
  },
  'order_type': {
    describe: true,
    title: '单据类型',
    type: 'select',
    equation: city,
    dictionary: 'A0011'
  },
  'report_type': {
    describe: true,
    title: '提报类型',
    type: 'select',
    equation: city,
    dictionary: 'A0001'
  },
  'plan_type': {
    describe: true,
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002',
    width: 200
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'customer_type': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'porder_status': {
    describe: true,
    title: '状态',
    type: 'select',
    equation: city,
    dictionary: 'A0025'
  },
  'remark': {
    title: '备注',
    type: 'input',
    equation: cusname
  },
  'create_name': {
    title: '创建人',
    type: 'input',
    equation: cusname
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue),
    defaultVal: new Date()
  },
  'wlybrand': {
    describe: true,
    showDescribeInput: true,
    describeTitle: '存货分类描述',
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019'
  },
  'sal_center': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'adj_reason': {
    describe: true,
    title: '变更原因',
    type: 'select',
    equation: all,
    dictionary: 'A0003'
  },
  'zzfld00003e': {
    describe: true,
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base'
  },
  'gjahr': {
    title: '年度',
    type: 'year',
    equation: city
  },
  'monat': {
    title: '月份',
    type: 'select',
    equation: city,
    dictionary: 'month'
  },
  'plan_qty': {
    title: '计划量(件)',
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    },
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_bot': {
    title: '计划量(瓶)',
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    },
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_amt': {
    title: '计划额(万元)',
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    },
    xlsxFmt: {
      t: 'n'
    }
  },
  'approval_no': {
    title: '签约审批单号',
    type: 'input',
  },
}



// WEBPACK FOOTER //
// ./src/views/sale-plan-manage/config/salePlanOrderQuery.js